import { Maybe } from '@codegrade/maybe';
import { NonEmptyList } from '@codegrade/non-empty-list';
import { getStoreBuilder } from '@codegrade/vuex-typex';
import * as utils from '@/utils';
const storeBuilder = getStoreBuilder();
/** @returns An empty initial state. */
function makeInitialState() {
    return {};
}
const moduleBuilder = storeBuilder.module('ai-tool-use-context', makeInitialState());
/** The store for the AI tool use context. */
export var AIToolUseContextStore;
(function (AIToolUseContextStore) {
    /** Get the current context, or `Nothing` if it is empty. */
    AIToolUseContextStore.get = moduleBuilder.read((state) => Maybe.of(state).filter(s => NonEmptyList.isNonEmpty(Object.keys(s))), 'get');
    const commitClearAll = moduleBuilder.commit(state => {
        Object.assign(state, makeInitialState());
    }, 'commitClearAll');
    /** Update the editor session information. */
    AIToolUseContextStore.setEditorSession = moduleBuilder.commit((state, editorSession) => {
        editorSession.caseOf({
            Nothing: () => utils.vueDelete(state, 'editorSession'),
            Just: ctx => utils.vueSet(state, 'editorSession', ctx),
        });
    }, 'setEditorSession');
    /** Update the quiz question information. */
    AIToolUseContextStore.setQuizQuestion = moduleBuilder.commit((state, quizQuestion) => {
        quizQuestion.caseOf({
            Nothing: () => utils.vueDelete(state, 'quizQuestion'),
            Just: ctx => utils.vueSet(state, 'quizQuestion', ctx),
        });
    }, 'setQuizQuestion');
    /** Update the Jupyter notebook information. */
    AIToolUseContextStore.setJupyterQuestion = moduleBuilder.commit((state, jupyterQuestion) => {
        jupyterQuestion.caseOf({
            Nothing: () => utils.vueDelete(state, 'jupyterQuestion'),
            Just: ctx => utils.vueSet(state, 'jupyterQuestion', ctx),
        });
    }, 'setJupyterQuestion');
    utils.signal.AFTER_USER_CHANGED.register(async () => {
        commitClearAll();
    });
})(AIToolUseContextStore || (AIToolUseContextStore = {}));
